// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M11 22H2V2H11V22Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 22H13V2H22V22Z"}}]};

const ColumnLayoutFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'column-layout-filled',
    ref,
    icon: element,
  },
));

ColumnLayoutFilledIcon.displayName = 'ColumnLayoutFilledIcon';

export default ColumnLayoutFilledIcon;
